<template>
  <div class="rich-text app-rich-text">
    <component
        :is="useBlockEditorBlock(component)"
        v-for="component in data.blocks"
        :key="component.id"
        :type="component.type"
        v-bind="safeBindTransform(component.data)"
    />
  </div>
</template>

<script setup lang="ts">
import {safeBindTransform} from '~/utils/data-transformers'
import {useBlockEditorBlock} from "~/composables/useBlockEditorBlock";

const props = defineProps<{
  data: {
    time: Number,
    blocks: Object,
    version: String
  }
}>()

</script>

<style scoped lang="postcss">
/*  */
</style>
